(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const initialized = new WeakSet();

  const markVisible = (scope = document) => {
    const items = scope.querySelectorAll?.('[data-griit-reveal]') || [];
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => { item.dataset.griitVisible = 'true'; });
      return;
    }

    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.griitVisible = 'true';
        instance.unobserve(entry.target);
      });
    }, { threshold: 0.28, rootMargin: '0px 0px -8% 0px' });

    items.forEach((item) => observer.observe(item));
  };

  const initProductReveal = (container) => {
    if (initialized.has(container)) return;
    const target = container.querySelector('.product-media-container, .griit-design-summary__art, .media-block');
    if (!target) return;

    initialized.add(container);
    target.classList.add('griit-tilt-target');

    const reset = () => {
      container.classList.remove('is-griit-dragging');
      container.style.setProperty('--griit-tilt-x', '0deg');
      container.style.setProperty('--griit-tilt-y', '0deg');
    };

    const update = (event) => {
      if (reducedMotion.matches) return;
      if (event.pointerType !== 'mouse' && !container.classList.contains('is-griit-dragging')) return;
      const rect = container.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
      container.style.setProperty('--griit-tilt-x', `${((0.5 - y) * 7).toFixed(2)}deg`);
      container.style.setProperty('--griit-tilt-y', `${((x - 0.5) * 9).toFixed(2)}deg`);
    };

    container.addEventListener('pointerdown', (event) => {
      if (reducedMotion.matches) return;
      container.classList.add('is-griit-dragging');
      container.setPointerCapture?.(event.pointerId);
      update(event);
    });
    container.addEventListener('pointermove', update, { passive: true });
    container.addEventListener('pointerup', reset);
    container.addEventListener('pointercancel', reset);
    container.addEventListener('pointerleave', reset);
  };

  const initMagnetic = (button) => {
    if (initialized.has(button) || !finePointer.matches || reducedMotion.matches) return;
    initialized.add(button);
    button.addEventListener('pointermove', (event) => {
      const rect = button.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 7;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 5;
      button.style.setProperty('--griit-magnetic-x', `${x.toFixed(1)}px`);
      button.style.setProperty('--griit-magnetic-y', `${y.toFixed(1)}px`);
    });
    button.addEventListener('pointerleave', () => {
      button.style.removeProperty('--griit-magnetic-x');
      button.style.removeProperty('--griit-magnetic-y');
    });
  };

  const init = (scope = document) => {
    markVisible(scope);
    scope.querySelectorAll?.('[data-griit-product-reveal]').forEach(initProductReveal);
    scope.querySelectorAll?.('.button:not(.button-unstyled), .griit-event-partner__button, .griit-team__button, .griit-gallery__cta, .gpx-btn-next, .gpx-btn-send').forEach(initMagnetic);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
